import React, { useState, useRef, useEffect } from "react";
import "./58MM/printmob.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ToWords } from "to-words";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import ReactToPrint from "react-to-print";
import { useDbContext } from "../../context/DbContext";
import { ClipLoader } from "react-spinners";
import HamburgerMenu from "./PrintMenu/HamburgerMenu";
import { useSelector } from "react-redux";
import { selectGeneralSettings } from "../../app/settingsSlice";

function PrintMob() {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const navigate = useNavigate();

  const [companyName, setCompanyName] = useState("");
  const [loading, setLoading] = useState(false);
  const [accumulatedWt, setaccumulatedWt] = useState("");
  const [oldBalance, setOldBalance] = useState(0);

  const GeneralSettings = useSelector(selectGeneralSettings);
  const obSetting = GeneralSettings.find(
    (item) => item.Name === "ENABLE OB IN SCHEME RECEIPT PRINT"
  );
  const showOB = obSetting && obSetting.ss_status === 1;

  const printRef = useRef();
  const location = useLocation();
  const { receiptData, receiptInfo, totalWt } = location.state || {};

  useEffect(() => {
    fetchcompanydetails();
  }, []);

  const fetchcompanydetails = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/findCompanyDetails/${dbCode}`
      );
      const foundData = response.data[0];
      setCompanyName(foundData.name || "SherGold");
    } catch (error) {
      console.error("Error fetching company datas:", error.message);
    }
  };

  const fetchData = async () => {
    try {
      const led = receiptData[0]?.name?.[0] || receiptData[0]?.name;
      const cleanLed = Array.isArray(led) ? led[0] : (led?.value ?? led);
      const entryNo = receiptInfo?.EntryNo || "";
      const currentFrmId = receiptInfo?.frmID || "";
      const response = await axios.get(
        `${apiBaseUrl}/main/recbalances/${cleanLed}/${dbCode}?entryNo=${entryNo}&frmId=${currentFrmId}`
      );
      if (response.data && response.data[0]) {
        const b = response.data[0];
        const isSaved = b.isSaved === 1 || b.isSaved === true;
        const currentWt = parseFloat(receiptData[0]?.totalGm || receiptData[0]?.gm || 0);
        setOldBalance(parseFloat(b.oldBalance || 0));
        if (isSaved) {
          setaccumulatedWt(parseFloat(b.totalWeight || 0));
        } else {
          setaccumulatedWt(parseFloat(b.oldWeight || 0) + currentWt);
        }
      } else {
        const fallbackRes = await axios.get(
          `${apiBaseUrl}/main/totalweight/${cleanLed}/${dbCode}`
        );
        setaccumulatedWt(fallbackRes.data[0]?.WeightDifference || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (receiptData && receiptData.length) {
      fetchData();
      const ledcode = receiptData[0]?.name?.[0] || receiptData[0]?.name;
      if (ledcode) {
        fetchOldBalance(ledcode);
      }
    }
  }, [receiptData]);

  const fetchOldBalance = async (ledcode) => {
    try {
      const cleanLed = Array.isArray(ledcode) ? ledcode[0] : (ledcode?.value ?? ledcode);
      const response = await axios.get(
        `${apiBaseUrl}/main/recprintob/${cleanLed}/${dbCode}`
      );
      if (!oldBalance) {
        setOldBalance(parseFloat(response.data[0]?.oldBalance || 0));
      }
    } catch (error) {
      console.error("Error fetching old balance:", error);
    }
  };

  if (!receiptData || !receiptInfo || !receiptData.length) {
    return null;
  }

  const toWords = new ToWords();

  // Helper function to hide menu and loader before capturing
  const hideElementsForCapture = () => {
    const menu = document.querySelector(".hamburger-menu-container");
    const loader = document.querySelector(".loading-overlay");
    
    if (menu) {
      menu.style.display = "none";
    }
    if (loader) {
      loader.style.display = "none";
    }
  };

  // Helper function to show menu and loader after capturing
  const showElementsAfterCapture = () => {
    const menu = document.querySelector(".hamburger-menu-container");
    const loader = document.querySelector(".loading-overlay");
    
    if (menu) {
      menu.style.display = "block";
    }
    if (loader) {
      loader.style.display = loading ? "flex" : "none";
    }
  };

  // PDF Download function
  const downloadPDF = () => {
    hideElementsForCapture();
    const printRoot = document.querySelector(".printRootmob");
    
    html2canvas(printRoot, { 
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff'
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("receipt.pdf");
      showElementsAfterCapture();
    }).catch(error => {
      console.error("Error generating PDF:", error);
      showElementsAfterCapture();
    });
  };

  // Print function using ReactToPrint
  const handlePrint = () => {
    hideElementsForCapture();
    // Trigger ReactToPrint
    const printTrigger = document.querySelector(".print-trigger");
    if (printTrigger) {
      printTrigger.click();
    }
    // Show menu again after a delay (print dialog opens)
    setTimeout(() => {
      showElementsAfterCapture();
    }, 1000);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
      date
    );
    const [day, month, year] = formattedDate.split(" ");
    return `${day}/${month}/${year}`;
  };

  // WhatsApp Functions
  const generatePDF = async (canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a5");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    return pdf.output("blob");
  };

  const uploadPDF = async (pdfBlob) => {
    const formData = new FormData();
    const newFileName = `receipt_${Date.now()}.pdf`;
    formData.append("id", "shergoldErp");
    formData.append("file", pdfBlob, newFileName);
    try {
      const uploadResponse = await axios.post(
        "https://imageupload.shersoft.tech/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (uploadResponse.status === 200) {
        return `https://imageupload.shersoft.tech/image/shergoldErp/${newFileName}`;
      } else {
        throw new Error("File upload failed");
      }
    } catch (error) {
      console.error("Error during file upload:", error);
      throw new Error("Failed to upload PDF");
    }
  };

  const fetchAccNmData = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/findbyaccnametable/${receiptData[0].name}/${dbCode}`
      );
      return response.data[0].mobileNo;
    } catch (error) {
      console.error("Error fetching data:", error.message);
      throw new Error("Failed to fetch account data");
    }
  };

  const fetchwhatsappsettings = async (eName) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectwhtAppapidatas/${dbCode}/${eName}`
      );
      return response.data[0];
    } catch (error) {
      console.error("Error fetching whtsappData Values:", error.message);
    }
  };

  const fetchWhatsAppsettings = async () => {
    try {
      const phNo = await fetchAccNmData();
      const response = await axios.get(
        `${apiBaseUrl}/main/selectwhtAppapidatas/${dbCode}/SCHEME RECEIPT`
      );
      const whtAppstngsData = response.data[0];
      const apiData = await fetchwhatsappsettings("SCHEME RECEIPT");
      
      const message = apiData.MessageBody
        .replace("${accountNo}", receiptData[0].accountNumber[1])
        .replace("${customerName}", receiptData[0].name[1])
        .replace("${total}", receiptData[0].total || receiptData[0].amount)
        .replace("Total:${grandTotal}", "")
        .replace("${netwt}", accumulatedWt || 0)
        .replace("${gm}", receiptData[0].totalGm || receiptData[0].gm);

      return {
        phoneNumber: phNo,
        appkey: whtAppstngsData.appKey,
        authkey: whtAppstngsData.Authkey,
        message: message,
        EntryName: whtAppstngsData.Voucher,
      };
    } catch (error) {
      console.error("Error in fetchWhatsAppsettings:", error);
      throw new Error("Failed to fetch WhatsApp settings");
    }
  };

  const generateAndUploadPDF = async () => {
    hideElementsForCapture();
    const printRoot = document.querySelector(".printRootmob");
    const originalBorder = printRoot.style.border;
    printRoot.style.border = "none";
    try {
      const canvas = await html2canvas(printRoot, { 
        scale: 1.5,
        useCORS: true,
        backgroundColor: '#ffffff',
        // Ensure canvas captures the clean content
        ignoreElements: (element) => {
          return element.classList && (
            element.classList.contains('loading-overlay') ||
            element.classList.contains('hamburger-menu-container')
          );
        }
      });
      const pdf = await generatePDF(canvas);
      const fileUrl = await uploadPDF(pdf);
      return fileUrl;
    } finally {
      showElementsAfterCapture();
      printRoot.style.border = originalBorder;
    }
  };

  // Helper function to send message via Rapiwha API
  const sendRapiwhaMessage = async (phoneNumber, appkey, text, mediaUrl = null) => {
    try {
      let apiUrl = `https://panel.rapiwha.com/send_message.php?apikey=${appkey}&number=91${phoneNumber}`;
      
      if (mediaUrl) {
        // For media, use text parameter to send the URL
        apiUrl += `&text=${encodeURIComponent(mediaUrl)}`;
      } else {
        // For regular message
        apiUrl += `&text=${encodeURIComponent(text)}`;
      }
      
      //////console.log("Sending request to:", apiUrl);
      
      const response = await axios.get(apiUrl);
      
      if (response.data && response.data.result_code === 0) {
        return { success: true, data: response.data };
      } else {
        throw new Error(response.data?.description || 'Failed to send message');
      }
    } catch (error) {
      console.error("Error sending Rapiwha message:", error);
      throw error;
    }
  };

  // Updated WhatsApp sending function
  const sendToWhatsApp = async () => {
    try {
      setLoading(true);
      
      const whatsAppData = await fetchWhatsAppsettings();
      
      // Generate PDF
      const fileUrl = await generateAndUploadPDF();
      
      // Send messages using Rapiwha API
      if (fileUrl && whatsAppData.message) {
        // Send media first, then message
        await sendRapiwhaMessage(
          whatsAppData.phoneNumber,
          whatsAppData.appkey,
          fileUrl
        );
        
        // Send text message
        await sendRapiwhaMessage(
          whatsAppData.phoneNumber,
          whatsAppData.appkey,
          whatsAppData.message
        );
        
        alert("Message and PDF sent successfully!");
      } else if (fileUrl) {
        // Send only media
        await sendRapiwhaMessage(
          whatsAppData.phoneNumber,
          whatsAppData.appkey,
          fileUrl
        );
        alert("PDF sent successfully!");
      } else if (whatsAppData.message) {
        // Send only message
        await sendRapiwhaMessage(
          whatsAppData.phoneNumber,
          whatsAppData.appkey,
          whatsAppData.message
        );
        alert("Message sent successfully!");
      } else {
        alert("Nothing to send - both message and PDF are empty");
      }
      
    } catch (error) {
      console.error("Error in sendToWhatsApp:", error);
      alert(error.message || "Failed to send message");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate(-1);
  };

  const spinnerProps = {
    color: "#026CC3",
    height: 12,
    width: 5,
    radius: 1,
    margin: 3,
    size: 30,
    speedMultiplier: 0.8,
    css: {
      opacity: "0.8",
    },
  };

  return (
    <div className="printRootmob">
      {/* Loading Overlay with unique class */}
      {loading && (
        <div
          className="loading-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 1000,
          }}
        >
          <ClipLoader {...spinnerProps} />
        </div>
      )}
      
      {/* Hamburger Menu Container */}
      <div className="hamburger-menu-container absolute !top-0 z-50">
        <HamburgerMenu
          onPrint={handlePrint}
          onDownloadPDF={downloadPDF}
          onSendWhatsApp={sendToWhatsApp}
          onClose={handleClose}
          loading={loading}
        />
      </div>

      {/* Hidden print trigger for ReactToPrint */}
      <ReactToPrint
        trigger={() => (
          <button className="print-trigger" style={{ display: "none" }}>
            Print
          </button>
        )}
        content={() => printRef.current}
        onBeforeGetContent={() => hideElementsForCapture()}
        onAfterPrint={() => showElementsAfterCapture()}
      />

      <div className="printBodymob" ref={printRef}>
        {/* Receipt Content - This part gets captured for PDF/Print */}
        <div className="printHeadmob">
          <label htmlFor="" className="receiptHeadmob">
            RECEIPT
          </label>
          <label htmlFor="" className="receiptCompanyNamemob">
            {companyName}
          </label>
        </div>
        <div id="printContentmob" className="printContentmob">
          <div className="printContentBodymob">
            <div className="printContentBodyRow1mob">
              <div className="printContentBodyRow1sec1mob">
                <span className="RecPrintfontsizemob">No.</span>
                <span className="RecPrintfontsizemob printmobentryno">
                  {receiptInfo.EntryNo} -{" "}
                  {receiptData[0].agent[1].substring(0, 3)}
                </span>
              </div>
              <div className="printContentBodyRow1sec2mob">
                <span className="RecPrintfontsizemob">Date:</span>
                <span className="recMobdateSpanmob RecPrintfontsizemob">
                  {formatDate(receiptInfo.date)}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2mob">
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob">Account Number</span>
              </div>
              <div className="printContentBodyRow2secmob">
                <span
                  style={{ fontWeight: "600" }}
                  className="recMarginmob Recboldfontsizemob"
                >
                  {receiptData[0].accountNumber[1]}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2mob">
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob">Received From</span>
              </div>
              <div className="printContentBodyRow2secmob">
                <span
                  style={{ fontWeight: "600" }}
                  className="recMarginmob Recboldfontsizemob"
                >
                  {receiptData[0].name[1]}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2mob">
              <div className="printContentBodyRow2secmob ">
                <span className="RecPrintfontsizemob sofrup">
                  The sum of rupees
                </span>
              </div>
              <div className="printContentBodyRow2secmob srupword">
                <span className="RecPrintfontsizemob recMarginmob wordssizemob ">
                  {toWords.convert(receiptData[0].total || receiptData[0].amount, { currency: false })}
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2mob">
              <div className="printContentBodyRow2secmob">
                <span
                  style={{ fontStyle: "italic" }}
                  className="bycashspanmob RecPrintfontsizemob"
                >
                  By Cash / cheque/DD No
                </span>
              </div>
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob recMarginmob">CASH</span>
              </div>
            </div>
            <div className="printContentBodyRow2mob  ">
              <div className="printContentBodyRow2secmob amntdiv">
                <div className="printContentBodyRow2secAmntmob">
                  <div className="printContentBodyRow2secAmntsec1mob">
                    <span className="rupeeSignmob" style={{ color: "white" }}>
                      ₹
                    </span>
                  </div>
                  <div className="printContentBodyRow2secAmntsec2mob">
                    {receiptData[0].total || receiptData[0].amount}
                  </div>
                </div>
              </div>
              <div className="printContentBodyRow2secmob"></div>
            </div>
            <div className="printContentBodyRow2mob">
              <span className="pritnFooterDatamob RecPrintfontsizemob">
                * All Cheque / DD are subject to realization
              </span>
            </div>
            <div className="printContentBodyRow2mob">
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob">Rate/Gm</span>
              </div>
              <div className="printContentBodyRow2secmob">
                <span
                  className="rupeeSignmob recMarginmob"
                  style={{ marginRight: "4px", marginLeft: 0 }}
                >
                  ₹
                </span>
                <span
                  className="RecPrintfontsizemob "
                  style={{ marginLeft: "0" }}
                >
                  {receiptInfo.rate}
                </span>
              </div>
            </div>

            <div className="printContentBodyRow2mob recWght">
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob">Weight</span>
              </div>
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob recMarginmob">
                  {receiptData[0].totalGm || receiptData[0].gm}&nbsp;gm
                </span>
              </div>
            </div>
            <div className="printContentBodyRow2mob recWght">
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob">Total Weight</span>
              </div>
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob recMarginmob">
                  {accumulatedWt || 0}&nbsp;gm
                </span>
              </div>
            </div>
                         <div className="printContentBodyRow2mob recWght">
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob">Total Amount</span>
              </div>
              <div className="printContentBodyRow2secmob">
                <span className="RecPrintfontsizemob recMarginmob">
                  ₹&nbsp;{(parseFloat(receiptData[0]?.total || receiptData[0]?.amount || 0) + parseFloat(oldBalance || 0)).toFixed(2)}
                </span>
              </div>
            </div>
            {showOB && (
              <div className="printContentBodyRow2mob recWght">
                <div className="printContentBodyRow2secmob">
                  <span className="RecPrintfontsizemob">Old Balance</span>
                </div>
                <div className="printContentBodyRow2secmob">
                  <span className="RecPrintfontsizemob recMarginmob">
                    ₹&nbsp;{(oldBalance || 0).toFixed(2)}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="printContentBodyfootermob">
            <span className="RecPrintfontsizemob">Receiver Signature</span>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrintMob;